import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const flexWrapperFn = /* @__PURE__ */ createRecipe('flex-wrapper', {}, [])

const flexWrapperVariantMap = {
  "direction": [
    "row",
    "column"
  ],
  "directionM": [
    "row",
    "column"
  ],
  "directionL": [
    "row",
    "column"
  ],
  "gap": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "gapM": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "gapL": [
    "gap100",
    "gap200",
    "gap300",
    "gap400",
    "gap500",
    "gap600",
    "gap700",
    "gap800",
    "gap900"
  ],
  "wrap": [
    "wrap",
    "nowrap"
  ],
  "align": [
    "start",
    "end",
    "stretch",
    "center",
    "baseline"
  ],
  "alignM": [
    "start",
    "end",
    "stretch",
    "center",
    "baseline"
  ],
  "alignL": [
    "start",
    "end",
    "stretch",
    "center",
    "baseline"
  ],
  "justify": [
    "start",
    "end",
    "center",
    "spaceBetween",
    "spaceAround",
    "spaceEvenly"
  ],
  "justifyM": [
    "start",
    "end",
    "center",
    "spaceBetween",
    "spaceAround",
    "spaceEvenly"
  ],
  "justifyL": [
    "start",
    "end",
    "center",
    "spaceBetween",
    "spaceAround",
    "spaceEvenly"
  ]
}

const flexWrapperVariantKeys = Object.keys(flexWrapperVariantMap)

export const flexWrapper = /* @__PURE__ */ Object.assign(memo(flexWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'flexWrapper',
  __getCompoundVariantCss__: flexWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: flexWrapperVariantKeys,
  variantMap: flexWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, flexWrapperVariantKeys)
  },
  getVariantProps: flexWrapperFn.getVariantProps,
})